import React, { useContext } from "react";
import { Link } from 'react-router-dom';
import SearchBar from './SearchBar';
import AuthContext from "../../context/AuthProvider";
const ListLayout = ({
  title,
  searchQuery,
  onSearchChange,
  searchPlaceholder,
  addButtonLink,
  addButtonTitle,
  children,
  showAddButton = false,
  extraButton,
}) => {
  const { auth } = useContext(AuthContext);

  return (
    <>

      <div className="col-lg-12 mb-lg-0 mb-4">
        <div className="card rounded-2 shadow-sm border-0">
          {title && <div className="card-header py-3 bg-brand bg-gradient">
            <h5 className="mb-0 text-white" style={{ fontSize: '1.1rem', fontWeight: '500' }}>
              <i className="bi bi-list-ul me-2"></i>
              {title}
            </h5>
            {extraButton && <div>{extraButton}</div>}
          </div>}
          <div className="card-body p-4">
            <div className="row">
              <div className="container">
                <div className="row align-items-center justify-content-between">
                  {searchPlaceholder && (<div className="col-md-6 col-12 order-md-1 order-2 mt-md-0 my-2">
                    <SearchBar
                      value={searchQuery}
                      onChange={onSearchChange}
                      placeholder={searchPlaceholder}
                    />
                  </div>)}

                  {addButtonLink && (
                    <>
                      <div className="col-md-3 col-12 order-md-2 order-1">
                        <Link
                          to={addButtonLink}
                          className="btn btn-brand btn-md w-100 mb-0 me-3 mb-1"
                          style={{ fontSize: '0.9rem' }}
                        >
                          <i className="bi bi-plus-circle-fill" aria-hidden="true"></i> {addButtonTitle}
                        </Link>
                      </div>
                    </>

                  )}


                </div>
                <div className="row">
                  <div className="col-md-12 col-12 mt-2 ">
                    {children}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListLayout;
